import axios from 'axios';
import * as endPoints from '../../../../Constants/Endpoints'

export function PasswordResetRequest(email) {
    var reason = "password reset"
    const reset = {
        email,
        reason
        }

    return axios.post(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.PasswordResetRequest, reset,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function ResetPasswordCall(password, reason) {
    const reset = {
        password,
        reason
        }

    return axios.post(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.ResetPassword, reset,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}
